import { z } from "zod";

const uuidV7 = z.uuid({ version: "v7" });

export const idSchema = <Kind extends string>(kind: Kind): ReturnType<typeof uuidV7.brand<Kind>> =>
  uuidV7.brand(kind);

export const entityIdSchema = idSchema("EntityId");
export type EntityId = z.infer<typeof entityIdSchema>;

const entityKindIdSchema = <Kind extends string>(kind: Kind): ReturnType<typeof entityIdSchema.brand<Kind>> =>
  entityIdSchema.brand(kind);

export const householdIdSchema = idSchema("HouseholdId");
export type HouseholdId = z.infer<typeof householdIdSchema>;

export const firmIdSchema = idSchema("FirmId");
export type FirmId = z.infer<typeof firmIdSchema>;

export const firmMemberIdSchema = idSchema("FirmMemberId");
export type FirmMemberId = z.infer<typeof firmMemberIdSchema>;

export const assignmentIdSchema = idSchema("AssignmentId");
export type AssignmentId = z.infer<typeof assignmentIdSchema>;

export const shareIdSchema = idSchema("ShareId");
export type ShareId = z.infer<typeof shareIdSchema>;

export const shareLinkIdSchema = idSchema("ShareLinkId");
export type ShareLinkId = z.infer<typeof shareLinkIdSchema>;

export const documentVersionIdSchema = idSchema("DocumentVersionId");
export type DocumentVersionId = z.infer<typeof documentVersionIdSchema>;

export const documentUploadIdSchema = idSchema("DocumentUploadId");
export type DocumentUploadId = z.infer<typeof documentUploadIdSchema>;

// WHY: Supabase Auth issues v4 user ids, so a user id is any UUID rather than a UUIDv7.
export const userIdSchema = z.uuid().brand("UserId");
export type UserId = z.infer<typeof userIdSchema>;

export const propertyIdSchema = entityKindIdSchema("PropertyId");
export type PropertyId = z.infer<typeof propertyIdSchema>;

export const zoneIdSchema = entityKindIdSchema("ZoneId");
export type ZoneId = z.infer<typeof zoneIdSchema>;

export const assetIdSchema = entityKindIdSchema("AssetId");
export type AssetId = z.infer<typeof assetIdSchema>;

export const personIdSchema = entityKindIdSchema("PersonId");
export type PersonId = z.infer<typeof personIdSchema>;

export const organizationIdSchema = entityKindIdSchema("OrganizationId");
export type OrganizationId = z.infer<typeof organizationIdSchema>;

export const personFactIdSchema = entityKindIdSchema("PersonFactId");
export type PersonFactId = z.infer<typeof personFactIdSchema>;

export const personRelationIdSchema = idSchema("PersonRelationId");
export type PersonRelationId = z.infer<typeof personRelationIdSchema>;

export const taskIdSchema = entityKindIdSchema("TaskId");
export type TaskId = z.infer<typeof taskIdSchema>;

export const taskSeriesIdSchema = entityKindIdSchema("TaskSeriesId");
export type TaskSeriesId = z.infer<typeof taskSeriesIdSchema>;

export const listIdSchema = entityKindIdSchema("ListId");
export type ListId = z.infer<typeof listIdSchema>;

export const listItemIdSchema = entityKindIdSchema("ListItemId");
export type ListItemId = z.infer<typeof listItemIdSchema>;

export const templateIdSchema = entityKindIdSchema("TemplateId");
export type TemplateId = z.infer<typeof templateIdSchema>;

export const eventIdSchema = entityKindIdSchema("EventId");
export type EventId = z.infer<typeof eventIdSchema>;

export const logEntryIdSchema = entityKindIdSchema("LogEntryId");
export type LogEntryId = z.infer<typeof logEntryIdSchema>;

export const documentIdSchema = entityKindIdSchema("DocumentId");
export type DocumentId = z.infer<typeof documentIdSchema>;

export const manualPageIdSchema = entityKindIdSchema("ManualPageId");
export type ManualPageId = z.infer<typeof manualPageIdSchema>;

export const vaultItemIdSchema = entityKindIdSchema("VaultItemId");
export type VaultItemId = z.infer<typeof vaultItemIdSchema>;

export const commentIdSchema = entityKindIdSchema("CommentId");
export type CommentId = z.infer<typeof commentIdSchema>;

export const projectIdSchema = entityKindIdSchema("ProjectId");
export type ProjectId = z.infer<typeof projectIdSchema>;

export const contractIdSchema = entityKindIdSchema("ContractId");
export type ContractId = z.infer<typeof contractIdSchema>;

export const projectPhaseIdSchema = entityKindIdSchema("ProjectPhaseId");
export type ProjectPhaseId = z.infer<typeof projectPhaseIdSchema>;

export const projectCategoryIdSchema = entityKindIdSchema("ProjectCategoryId");
export type ProjectCategoryId = z.infer<typeof projectCategoryIdSchema>;

export const projectQuoteIdSchema = entityKindIdSchema("ProjectQuoteId");
export type ProjectQuoteId = z.infer<typeof projectQuoteIdSchema>;

export const projectInvoiceIdSchema = entityKindIdSchema("ProjectInvoiceId");
export type ProjectInvoiceId = z.infer<typeof projectInvoiceIdSchema>;

export const projectPaymentIdSchema = entityKindIdSchema("ProjectPaymentId");
export type ProjectPaymentId = z.infer<typeof projectPaymentIdSchema>;

export const projectLineIdSchema = entityKindIdSchema("ProjectLineId");
export type ProjectLineId = z.infer<typeof projectLineIdSchema>;

export const shiftPatternIdSchema = entityKindIdSchema("ShiftPatternId");
export type ShiftPatternId = z.infer<typeof shiftPatternIdSchema>;

export const shiftIdSchema = entityKindIdSchema("ShiftId");
export type ShiftId = z.infer<typeof shiftIdSchema>;

export const absenceIdSchema = entityKindIdSchema("AbsenceId");
export type AbsenceId = z.infer<typeof absenceIdSchema>;

export const leaveAllowanceIdSchema = entityKindIdSchema("LeaveAllowanceId");
export type LeaveAllowanceId = z.infer<typeof leaveAllowanceIdSchema>;

export const leaveAdjustmentIdSchema = entityKindIdSchema("LeaveAdjustmentId");
export type LeaveAdjustmentId = z.infer<typeof leaveAdjustmentIdSchema>;
